import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  ParticipantBulkDeleteRequest,
  ParticipantListRequest,
  ParticipantListResponse,
  ParticipantListUpdateRequest,
  ParticipantOptionListRequest,
  ParticipantOptionListResponse,
  Schedule,
  ScheduleCreateRequest,
  ScheduleListRequest,
  ScheduleListResponse,
  ScheduleOptionListRequest,
  ScheduleOptionListResponse,
  ScheduleTimeScheduleParticipantBulkUpdateRequest,
  ScheduleUpdateRequest,
  TimeScheduleBulkDeleteRequest,
  TimeScheduleListRequest,
  TimeScheduleListResponse,
  TimeScheduleListUpdateRequest,
} from "./types";

export const scheduleListService = (params: ScheduleListRequest) =>
  RestAPIClient.call<ScheduleListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      params,
      requireAuthentication: true,
    },
  });

export const scheduleOptionListService = (params: ScheduleOptionListRequest) =>
  RestAPIClient.call<ScheduleOptionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.OptionList,
    config: {
      params,
      requireAuthentication: true,
    },
  });

export const scheduleDetailService = (id: string) =>
  RestAPIClient.call<Schedule>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const scheduleCreateService = (params: ScheduleCreateRequest) =>
  RestAPIClient.call<Schedule>({
    method: HTTPRequestMethods.POST,
    data: params,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
  });

export const scheduleUpdateService = ({
  id,
  ...innerPrams
}: ScheduleUpdateRequest) =>
  RestAPIClient.call<Schedule>({
    method: HTTPRequestMethods.PUT,
    data: innerPrams,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const scheduleParticipantListService = ({
  scheduleId,
  ...innerParams
}: ParticipantListRequest) =>
  RestAPIClient.call<ParticipantListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${scheduleId}/participant`,
    config: {
      params: innerParams,
      requireAuthentication: true,
    },
  });

export const scheduleParticipantOptionListService = ({
  scheduleId,
  ...innerParams
}: ParticipantOptionListRequest) =>
  RestAPIClient.call<ParticipantOptionListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${scheduleId}/participant/dropdown`,
    config: {
      params: innerParams,
      requireAuthentication: true,
    },
  });

export const scheduleParticipantBulkUpdateService = ({
  scheduleId,
  data,
}: ParticipantListUpdateRequest) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.PUT,
    data,
    url: `${Paths.Update}/${scheduleId}/participant`,
    config: {
      requireAuthentication: true,
    },
  });

export const scheduleParticipantBulkDeleteService = ({
  scheduleId,
  ...innerParams
}: ParticipantBulkDeleteRequest) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${scheduleId}/participants`,
    config: {
      params: innerParams,
      requireAuthentication: true,
    },
  });

export const scheduleTimeScheduleListService = ({
  scheduleId,
  ...innerParams
}: TimeScheduleListRequest) =>
  RestAPIClient.call<TimeScheduleListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${scheduleId}/time-schedule`,
    config: {
      params: innerParams,
      requireAuthentication: true,
    },
  });

export const scheduleTimeScheduleBulkUpdateService = ({
  scheduleId,
  data,
}: TimeScheduleListUpdateRequest) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.PUT,
    data,
    url: `${Paths.Update}/${scheduleId}/time-schedule`,
    config: {
      requireAuthentication: true,
    },
  });

export const scheduleTimeScheduleBulkDeleteService = ({
  scheduleId,
  ...innerParams
}: TimeScheduleBulkDeleteRequest) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${scheduleId}/time-schedules`,
    config: {
      params: innerParams,
      requireAuthentication: true,
    },
  });

export const scheduleTimeScheduleParticipantBulkUpdateService = ({
  scheduleId,
  ...data
}: ScheduleTimeScheduleParticipantBulkUpdateRequest) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${scheduleId}/time-schedule-participant`,
    data,
    config: {
      requireAuthentication: true,
    },
  });
